module.exports = __WEBPACK_EXTERNAL_MODULE_66__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","router"],"commonjs":"@angular/router","commonjs2":"@angular/router","amd":"@angular/router"}
// module id = 66
// module chunks = 0 1